import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { JobApi } from '@/modules/jobs/types';
import { legalEndpoints } from '@/modules/legal/constants';

interface UpdateJobAiDisclosureVariables {
  jobId: string;
  enabled: boolean;
}

export const useUpdateJobAiDisclosureMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobId, enabled }: UpdateJobAiDisclosureVariables) => {
      const { data } = await fetchClient.PUT(legalEndpoints.jobAiDisclosure, {
        params: { path: { jobId } },
        body: { enabled },
      });
      return data;
    },
    onSuccess: (data, { jobId }) => {
      if (!data) return;
      queryClient.setQueryData<JobApi>(jobsQueryKeys.detail(jobId), (job) =>
        job
          ? { ...job, isAiDisclosureEnabled: data.isAiDisclosureEnabled }
          : job,
      );
    },
  });
};
